module.exports = "query TransportsInfosQuery{ciblexContracts{ciblexContractName ciblexContractKey ciblexContractLabel ciblexContractCuttoff}}"